import defined from '~app/core/defined';

export function patchLinks(domNode) {
  if (defined(domNode)) {
    const elementCollection = domNode.getElementsByTagName("a");
    for (let i = 0; i < elementCollection.length; ++i) {
      const a = elementCollection.item(i);
      a.target = "_blank";
      a.rel = "noopener";
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/patchLinks.js